export default "__VITE_ASSET__CmcPl345__"